/* @flow */
import { Observable } from 'rxjs';
import { prop } from 'ramda';
import { combineEpics } from 'redux-observable';
import type { ActionsObservable } from 'redux-observable';
import createDebugger from 'debug';
import { LOCATION_CHANGE } from 'react-router-redux';


const debug = createDebugger('app:modules:profile:epics'); // eslint-disable-line no-unused-vars

import * as ActionTypes from './action-types.js';
import * as Types from './types.js';
import * as Getters from './getters.js';
import * as Constants from './constants.js';
import { warn, error, success } from 'modules/alerts/actions.js';

const viewLoadedEpic = (action$: ActionsObservable<*>) =>
  action$.ofType(LOCATION_CHANGE)
    .map(prop('payload'))
    .filter((x) => {
      return x.pathname === '/settings/notifications';
    })
    .mergeMap(() => Observable.from([
      { type: ActionTypes.FETCH_PREFERENCES },
      { type: ActionTypes.FETCH_WATCHED_KEYWORDS },
    ]));

export const fetchPreferencesEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(ActionTypes.FETCH_PREFERENCES)
    .mergeMap(() =>
      ajax.get(Constants.NOTIFICATION_PREFERENCES_ENDPOINT)
        .mergeMap(({ response }) => ([{
          type: ActionTypes.FETCH_PREFERENCES_SUCCESS,
          payload: response,
        }]))
        .catch(err => Observable.from([{
          type: ActionTypes.FETCH_PREFERENCES_FAILURE,
          error: true,
          payload: err,
        },
          error('There was an error loading notification preferences.')
        ])));

export const updatePreferencesEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(ActionTypes.UPDATE_PREFERENCES)
    .mergeMap(({payload}) =>
      ajax.putJSON(Constants.NOTIFICATION_PREFERENCES_ENDPOINT, payload)
        .mergeMap(({ response }) => (Observable.from([{
          type: ActionTypes.UPDATE_PREFERENCES_SUCCESS,
          payload: response,
        },
        {
          type: ActionTypes.FETCH_PREFERENCES
        },
          success('Your notification preferences have been updated.')
        ])))
        .catch(err => Observable.from([{
          type: ActionTypes.UPDATE_PREFERENCES_FAILURE,
          error: true,
          payload: err,
        },
          error('There was an error saving your notification preferences.')
        ])));

export const fetchWatchedKeywordsEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(ActionTypes.FETCH_WATCHED_KEYWORDS)
    .mergeMap(() =>
      ajax.get(Constants.WATCHED_KEYWORDS_ENDPOINT)
        .map(({ response }) => ({
          type: ActionTypes.FETCH_WATCHED_KEYWORDS_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.from([{
          type: ActionTypes.FETCH_WATCHED_KEYWORDS_FAILURE,
          error: true,
          payload: err,
        },
          error('There was an error loading your watched keywords.')
        ])));

export const addWatchedKeywordEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(ActionTypes.ADD_WATCHED_KEYWORD)
    .mergeMap((action) =>
      ajax.postJSON(Constants.WATCHED_KEYWORDS_ENDPOINT, action.payload)
        .mergeMap(({response}) => (Observable.from([{
          type: ActionTypes.ADD_WATCHED_KEYWORD_SUCCESS,
          payload: response,
        },
        {
          type: ActionTypes.FETCH_WATCHED_KEYWORDS,
        },
          success('Your keyword has been added.')
        ])))
        .catch(err => Observable.from([{
          type: ActionTypes.ADD_WATCHED_KEYWORD_FAILURE,
          error: true,
          payload: err,
        },
          error('There was an error adding the watched keyword.')
        ])));

export const deleteWatchedKeywordEpic = (action$: ActionsObservable<*>, store: Store, { ajax }: Object) =>
  action$.ofType(ActionTypes.DELETE_WATCHED_KEYWORD)
    .mergeMap((action) =>
      ajax.delete(`${Constants.WATCHED_KEYWORDS_ENDPOINT}/${action.payload}`)
        .mergeMap(({response}) => (Observable.from([{
          type: ActionTypes.DELETE_WATCHED_KEYWORD_SUCCESS,
          payload: response,
        },
        {
          type: ActionTypes.FETCH_WATCHED_KEYWORDS,
        },
          success('Your keyword has been removed.')
        ])))
        .catch(err => Observable.from([{
          type: ActionTypes.DELETE_WATCHED_KEYWORD_FAILURE,
          error: true,
          payload: err,
        },
          error('There was an error deleting your watched keyword.')
        ])));

export default combineEpics(
  viewLoadedEpic,
  fetchPreferencesEpic,
  updatePreferencesEpic,
  fetchWatchedKeywordsEpic,
  addWatchedKeywordEpic,
  deleteWatchedKeywordEpic,
);


// WEBPACK FOOTER //
// ./src/app/modules/notificationPreferences/epics.js